import Validation from '../lib/validation'

function validate(data, role) {
  const validator = new Validation(data)
  if (role === 'SUPERVISOR' || role === 'ADMIN' || role === 'INSTRUCTOR') {
    validator.isRequired('firstName', 'Jméno není vyplněno')
    validator.isRequired('lastName', 'Příjmení není vyplněno')
    validator.isRequired('birthdate', 'Datum narození je povinné')
    validator.isDate('birthdate', 'Datum narození není ve správném formátu')
    validator.isRequired('company', 'Společnost je povinná')
    validator.isObjectId('company', 'ID Společnosti není ve správném formátu')
  }

  if (data.drivingLicenceExpireDate) {
    validator.isDate('drivingLicenceExpireDate', 'Datum expirace řidičského průkazu není ve správném formátu')
  }
  if (data.medicalExaminationExpireDate) {
    validator.isDate('medicalExaminationExpireDate', 'Datum expirace lékařské prohlídky není ve správném formátu')
  }
  if (data.trainingExpireDate) {
    validator.isDate('trainingExpireDate', 'Datum expirace školení není ve správném formátu')
  }
  if (data.adrExpirationDate) {
    validator.isDate('drivingLicenceExpireDate', 'Datum expirace ADR není ve správném formátu')
  }
  return validator.validate()
}

export const validateImport = (data) => {
  console.log("validation", data)
  const validator = new Validation(data)

  validator.isRequired('company', 'Společnost je povinná')
  validator.isObjectId('company', 'ID Společnosti není ve správném formátu')

  return validator.validate()
}

export const validateSupervisor = (data) => validate(data, 'SUPERVISOR')
export const validateAdmin = (data) => validate(data, 'ADMIN')
export const validateFleetManager = (data) => validate(data, 'FLEET_MANAGER')
export default validate



// WEBPACK FOOTER //
// ./src/common/drivers/validations.js